
  import { Vue, Component } from 'vue-property-decorator';
  import { Context } from '@nuxt/types';

  import BlockSlideshow from '~/components/blocks/block-slideshow.vue';
  import BlockFeatures from '~/components/blocks/block-features.vue';
  import BlockProductsCarousel from '~/components/blocks/block-products-carousel.vue';
  import BlockProductsCarouselContainer from '~/components/blocks/block-products-carousel-container.vue';
  import BlockBanner from '~/components/blocks/block-banner.vue';
  import BlockProducts from '~/components/blocks/block-products.vue';
  import BlockSale from '~/components/blocks/block-sale.vue';
  import BlockCategories from '~/components/blocks/block-categories.vue';
  import BlockPosts from '~/components/blocks/block-posts.vue';
  import BlockBrands from '~/components/blocks/block-brands.vue';
  import BlockProductColumns from '~/components/blocks/block-product-columns.vue';
  import { Getter } from 'vuex-class';

  async function loadColumns({ topRated, specialOffers, bestsellers }) {
    return [
      { title: 'Top Rated Products', products: await topRated },
      { title: 'Email Promotions', products: await specialOffers },
      { title: 'Bestsellers', products: await bestsellers },
    ];
  }

  @Component({
    components: {
      BlockSlideshow,
      BlockFeatures,
      BlockProductsCarousel,
      BlockProductsCarouselContainer,
      BlockBanner,
      BlockProducts,
      BlockCategories,
      BlockPosts,
      BlockBrands,
      BlockProductColumns,
      BlockSale,
    },
    async asyncData({ store }: Context) {
      store.commit('options/setHeaderLayout', 'default');
      store.commit('options/setDropcartType', 'dropdown');

      const categories = await store.dispatch('category/fetchCategories', {
        'page[size]': 3,
      });
      const sectionbanners = await store.dispatch(
        'sectionbanner/fetchSectionBanners',
        {}
      );
      const getProductsBySection = (section) => {
        if (sectionbanners) {
          return sectionbanners
            .filter((x) => {
              return x.section == section;
            })
            .map((x) => x.products)[0];
        }
      };

      const payload = {
        topRated: getProductsBySection('TR'),
        specialOffers: getProductsBySection('SO'),
        bestsellers: getProductsBySection('BS'),
      };

      return {
        banners: await store.dispatch('headerbanner/fetchHeaderBanners', {
          section: 'A',
        }),
        banner: await store.dispatch('headerbanner/fetchHeaderBanners', {
          section: 'B',
        }),
        featuredProducts: await getProductsBySection('F'),
        eventHall: await getProductsBySection('EH'),
        flashSale: await getProductsBySection('FS'),
        latestProducts: await getProductsBySection('LP'),
        latestNews: await getProductsBySection('LN'),
        retailPartnersProducts: await getProductsBySection('RP'),
        columns: await loadColumns(payload),
        categories: [
          { id: 0, name: 'All', categorySlug: undefined },
          ...categories,
        ],
      };
    },
    head() {
      return {
        title: 'Home',
      };
    },
  })
  export default class HomePageOne extends Vue {
    @Getter('sectionbanner/fetchSectionBanners') items!: any;

    featuredProductsSource(tab: any): Promise<any> {
      return this.getProductsBySection('F', tab.id);
    }

    latestProductsSource(tab: any): Promise<any> {
      return this.getProductsBySection('LP', tab.id);
    }

    retailPartnersProductsSource(tab: any): Promise<any> {
      return this.getProductsBySection('RP', tab.id);
    }

    getProductsBySection(section, id) {
      const lists = this.items
        .filter((x) => {
          return x.section == section;
        })
        .map((x) => x.products)[0];

      return id
        ? lists.filter((x) => {
            return x.categoryid == id;
          })
        : lists;
    }

    getKeyword(id) {
      const kw = this.items.find((obj) => obj.section === id)?.title;
      return kw;
    }
  }
